import React from "react";

const getBarColor = (value) => {
    if (value >= 75) return '#00AFB9'; // Green for high values
    if (value >= 50) return '#FFD166'; // Yellow for medium values
    if (value > 0) return '#EF476F'; // Red for low values
    return '#f07167'; // Default background color for 0
};

function ComplianceCard({ standard }) {
    // Convert decimal to percentage
    const complianceLevel = standard.AvgComplianceLevel 
        ? Math.round(parseFloat(standard.AvgComplianceLevel) * 100) // Convert decimal (0.5788 -> 57.88)
        : null;

    return (
        <div className="flex flex-col justify-between bg-white shadow-md rounded-md border border-gray-200 hover:shadow-lg transition-shadow w-64 h-72 p-4 mb-12">
            
            {/* Large Title Box */}
            <div className="w-full h-[40%] bg-[#3b3b3b] flex items-center justify-center rounded-md">
                <h3 className="text-lg font-bold text-white text-center text-xl px-2">
                    {standard.name}
                </h3>
            </div>

            {/* Description */}
            <h3 className="text-lg text-md font-bold text-gray-600 text-left pt-2 px-2">
                    {standard.name}
                </h3>
            <p className="text-xs text-gray-600 px-2">
                {standard.description || "No description available"}
            </p>

            {/* Compliance Level Bar */}
            <div className="flex flex-col w-full mt-2">
                <p className="text-sm font-bold ml-2 text-gray-600 mb-1">Compliance Level</p>
                <div className="relative w-48 ml-2 h-6 bg-[#999999] rounded-full flex items-center">
                    
                    <div
                        className="absolute h-full rounded-full"
                        style={{
                            width: `${complianceLevel || 0}%`,
                            backgroundColor: getBarColor(complianceLevel),
                        }}
                    />
                    <span className="relative text-white ml-2 text-xs w-full text-center">
                        {complianceLevel !== null ? `${complianceLevel}%` : 'No Data'}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ComplianceCard;